import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Icon, Select, Spin, Tooltip } from 'antd';
import { Merchant } from '../../../../models';
import TextArea from 'antd/lib/input/TextArea';
import { Text3 } from '../../../../styles';
import { PermissionHoc } from '../../../HOC';
import { generate_query_set, handleApiExceptions } from '../../../../app_methods';

const UpdatePermissableButton = PermissionHoc(Button, "MERCHANTS_WRITE", { is_component: true, fallbackComponent: null })


let MerchantForm = (props) => {
    const [entityTypes, setEntityTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { form, merchant } = props;
    const profile = merchant.profile || {};
    const { getFieldDecorator } = form;
    const validations = Merchant.validations;

    const getBuisnessEntityTypeList = async () => {
        setIsLoading(true);
        const response = await Merchant.entity_type_list();
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setEntityTypes(response.data.entity_types);
        setIsLoading(false);
    }

    useEffect(() => {
        getBuisnessEntityTypeList();
    }, []);



    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    };

    const renderBusinessForm = () => {
        return (
            <div className='p-3 rounded mb-3' style={{ backgroundColor: "#F8F8F8" }}>
                <Text3 className="ml-1" type="secondary">Business Details</Text3>
                <div className="row mt-1">
                    {getFieldDecorator("id", {
                            initialValue: merchant.id,
                            rules: validations.id
                        })(<Input autoComplete='off' hidden />)}
                    <div className="col-sm">
                        
                            <Form.Item label={<>
                            <span>Business Name</span>
                            <Tooltip title="Doing Business As (DBA) Name">
                                <Icon style={{ fontSize: 14, marginTop: "3px" }} className="ml-1" type="info-circle" />
                            </Tooltip>
                            </>}>
                                {getFieldDecorator("business_name", {
                                    initialValue: profile.business_name,
                                    rules: validations.business_name
                                })(<Input autoComplete='off' disabled={profile.internal_kyc_status === 2} prefix={<Icon type="shop" />} />)}
                            </Form.Item>
                        
                    </div>

                    <div className="col-sm">
                            <Form.Item label="Email ID">
                                {getFieldDecorator("email", {
                                    initialValue: merchant.email,
                                    rules: validations.email
                                })(<Input autoComplete='off' disabled={merchant.is_edit} prefix={<Icon type="mail" />} />)}
                            </Form.Item>
                        </div>

                    
                </div>

                    <div className="row mt-1">

                        
                        <div className="col-sm">
                        <Form.Item label="Phone No.">
                            {getFieldDecorator("phone", {
                                initialValue: merchant.phone,
                                rules: validations.phone
                            })(<Input autoComplete='off' prefix={<Icon type="phone" />} />)}
                        </Form.Item>
                        </div>

                        <div className="col-sm">
                        <Form.Item label="Business Entity Type">
                            {getFieldDecorator("entity_type", {
                                initialValue: profile.entity_type,
                                rules: validations.entity_type
                            })
                                (<Select
                                    autoComplete='off'
                                    disabled={profile.internal_kyc_status === 2}
                                    placeholder="Select Entity Type"
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }>

                                    {entityTypes.map((entity, index) => {
                                        return (
                                            <Select.Option key={index} value={entity.entity_type_id}>
                                                {entity.entity_type_name}
                                            </Select.Option>
                                        )
                                    })}
                                </Select>
                                )}
                        </Form.Item>
                    </div>
                    </div>           
            </div>
        )
    };

    const renderBankForm = () => {
        return (
            <div className='p-3 rounded mb-1' style={{ backgroundColor: "#F8F8F8" }}>
                <Text3 className="ml-1" type="secondary">Bank Details</Text3>
                <div className="row mt-1">
                    <div className="col-sm">
                        <Form.Item label="Name On Bank">
                            {getFieldDecorator("name_on_bank", {
                                initialValue: profile.name_on_bank,
                                rules: validations.name_on_bank
                            })(<Input autoComplete='off' disabled={profile.internal_kyc_status === 2} prefix={<Icon type="bank" />} />)}
                        </Form.Item>
                    </div>
                </div>

                <div className="row mt-1">
                    <div className="col-sm">
                        <Form.Item label="Bank Name">
                            {getFieldDecorator("bank_name", {
                                initialValue: profile.bank_name,
                                rules: validations.bank_name
                            })(<Input autoComplete='off' disabled={profile.internal_kyc_status === 2} prefix={<Icon type="bank" />} />)}
                        </Form.Item>
                    </div>

                    <div className="col-sm">
                        <Form.Item label="Bank Branch">
                            {getFieldDecorator("bank_branch", {
                                initialValue: profile.bank_branch,
                                rules: validations.bank_branch
                            })(<Input autoComplete='off' disabled={profile.internal_kyc_status === 2} prefix={<Icon type="bank" />} />)}
                        </Form.Item>
                    </div>


                </div>
                <div className="row mt-1">
                    <div className="col-sm">
                        <Form.Item label="Account Number">
                            {getFieldDecorator("account_number", {
                                initialValue: profile.account_number,
                                rules: validations.account_number
                            })(<Input autoComplete='off' disabled={profile.internal_kyc_status === 2} prefix={<Icon type="bank" />} />)}
                        </Form.Item>
                    </div>

                    <div className="col-sm">
                        <Form.Item label="IFSC Code">
                            {getFieldDecorator("account_ifsc", {
                                initialValue: profile.account_ifsc,
                                rules: validations.account_ifsc,
                                normalize: (input) => (input || "").toUpperCase(),
                            })(<Input autoComplete='off' disabled={profile.internal_kyc_status === 2} prefix={<Icon type="bank" />} />)}
                        </Form.Item>
                    </div>
                </div>
            </div>
        )
    };

    return (
        <Form onSubmit={onSubmit}>
            <div className="">{renderBusinessForm()}</div>
            <div className="">{renderBankForm()}</div>
            <div className="w-100 d-flex justify-content-end mt-4">
                <UpdatePermissableButton type="primary" htmlType="submit" loading={props.loading}>{merchant.is_edit ? "Update" : "Create"}</UpdatePermissableButton>
            </div>
        </Form>
    )
};

MerchantForm = Form.create()(MerchantForm);
export { MerchantForm };